export interface Intent {
    key: string;
    labelKey: string;
    img: string;
}

export const intents = [
    {
        key: 'project_management',
        labelKey:
            'broadIntentContent.hero.traditional.intents.project_management',
        img: '/marketing_site/paid/broad_intent_test/Project_management.png'
    },
    {
        key: 'scheduling',
        labelKey: 'broadIntentContent.hero.traditional.intents.scheduling',
        img: '/marketing_site/paid/broad_intent_test/Schedule.png'
    },
    {
        key: 'lead_management',
        labelKey: 'broadIntentContent.hero.traditional.intents.lead_management',
        img: '/marketing_site/paid/broad_intent_test/Lead_Management.png'
    },
    {
        key: 'proposals',
        labelKey: 'broadIntentContent.hero.traditional.intents.proposals',
        img: '/marketing_site/paid/broad_intent_test/Proposals.png'
    },
    {
        key: 'contracts',
        labelKey: 'broadIntentContent.hero.traditional.intents.contracts',
        img: '/marketing_site/paid/broad_intent_test/Contract.png'
    },
    {
        key: 'invoices',
        labelKey: 'broadIntentContent.hero.traditional.intents.invoices',
        img: '/marketing_site/paid/broad_intent_test/Invoice.png'
    },
    {
        key: 'automation',
        labelKey: 'broadIntentContent.hero.traditional.intents.automation',
        img: '/marketing_site/paid/broad_intent_test/Automation.png'
    }
];
